import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

const createDeal = async (dealData) => {
  try {
    const res = await API.create_deal(dealData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updateDeal = async (dealId, dealData) => {
  try {
    const res = await API.update_deal(dealId, dealData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getDealDetailsById = async (dealId) => {
  try {
    const res = await API.deal_details(dealId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getDealList = async (
  pageNum,
  filters,
  searchString,
  pageSize,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.deal_list(
      pageNum,
      filters,
      searchString,
      pageSize,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export { createDeal, updateDeal, getDealDetailsById, getDealList };
